import { createFileRoute, Navigate } from "@tanstack/react-router";
import type { JSX } from "react";

/** Angular dev `/auth/teams` -> React Teams login. */
const AuthTeamsRedirect = (): JSX.Element => <Navigate to="/teams/login" />;

export const Route = createFileRoute("/auth/teams/")({
	component: AuthTeamsRedirect,
});
